import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerAnimation = _resolveComponent("SpinnerAnimation")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    tabindex: "0",
    class: _normalizeClass([
      (_ctx.loading || _ctx.disabled) && 'cursor-not-allowed',
      _ctx.buttonClass,
      _ctx.themeClass,
      _ctx.rounded && 'rounded-custom',
      'relative btn-custom transition-all',
    ]),
    disabled: _ctx.loading || _ctx.disabled
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([
        (_ctx.loading || _ctx.disabled) && 'opacity-40',
        !(_ctx.loading || _ctx.disabled) && 'opacity-100',
        'transition-opacity inline-flex items-center',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SpinnerAnimation)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}